import { render, staticRenderFns } from "./PanelWithMaterialPurchaseRequestEditor.vue?vue&type=template&id=f559b5f0&lang=pug&"
import script from "./PanelWithMaterialPurchaseRequestEditor.vue?vue&type=script&lang=ts&"
export * from "./PanelWithMaterialPurchaseRequestEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithMaterialPurchaseRequestEditor.vue?vue&type=style&index=0&id=f559b5f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports